/**
 * @file MinimalFooter.jsx
 * @summary A minimal footer component for iframe/tool-only layouts that displays
 * basic authentication information without taking up much space.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './MinimalFooter.css';

const MinimalFooter = () => {
  const { currentUser, isLoggedIn } = useAuth();
  
  console.log('MinimalFooter: Rendering with:', { 
    isLoggedIn, 
    currentUser: currentUser ? {
      email: currentUser.email,
      role: currentUser.role,
      isAdmin: currentUser.isAdmin
    } : null 
  });

  if (!isLoggedIn || !currentUser) {
    return (
      <footer className="minimal-footer">
        <div className="minimal-footer-content">
          <span className="auth-status not-authenticated">
            <i className="fas fa-user-slash" aria-hidden="true"></i>
            Not authenticated
          </span>
        </div>
      </footer>
    );
  }

  const getRoleDisplay = () => {
    if (currentUser.isAdmin) return 'Admin';
    if (currentUser.role === 'student') return 'Student';
    return 'Educator';
  };

  const getStatusColor = () => {
    if (currentUser.isAdmin) return 'admin';
    if (currentUser.role === 'student') return 'student';
    return 'educator';
  };

  return (
    <footer className="minimal-footer">
      <div className="minimal-footer-content">
        {/* Powered by text - moved to far left */}
        <span className="powered-by">
          <i className="fas fa-briefcase" aria-hidden="true"></i>
          Defined @ Work
        </span>
        
        <span className={`auth-status ${getStatusColor()}`}>
          <i className="fas fa-user-check" aria-hidden="true"></i>
          Logged in as {getRoleDisplay()}: <span className="user-email">{currentUser.email}</span>
        </span>
        
        {/* My Activities Dashboard Link - moved to far right */}
        <Link to="/dashboard" className="dashboard-link" aria-label="Go to My Activities Dashboard">
          <i className="fas fa-tachometer-alt" aria-hidden="true"></i>
          My Activities
        </Link>
      </div>
    </footer>
  );
};

export default MinimalFooter; 